// TextFilter.jsx — debounced text input matching the app's filter contract.
import React, { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";

const TextFilter = ({ column, handleInputFilterChangeNoDebounce, placeholder }) => {
   const [local, setLocal] = useState(column?.value || "");
   useEffect(() => {
      setLocal(column?.value || "");
   }, [column?.value]);

   const debouncedRef = useRef(
      debounce((id, v) => handleInputFilterChangeNoDebounce(id, v), 300)
   );
   useEffect(() => {
      const d = debouncedRef.current;
      return () => d.cancel();
   }, []);

   return (
      <input
         className="form-control mt-2"
         type="text"
         placeholder={placeholder || `Search ${column.id}`}
         value={local}
         onChange={(e) => {
            setLocal(e.target.value);
            debouncedRef.current(column.id, e.target.value);
         }}
      />
   );
};
export default TextFilter;
